export default __webpack_public_path__ + "static/media/Spotify_icon.5017cf16.svg";